import { useCallback, useEffect } from "react";
export const useKeyDown = (
  callback: (e: KeyboardEvent) => void,
  options: { code: string; key?: never } | { key: string; code?: never },
) => {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (options.code && e.code === options.code) {
      callback.apply(callback, [e]);
    } else if (options.key && e.key === options.key) {
      callback.apply(callback, [e]);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
};
